import React from "react";
import {loadingSpin} from "./routingContainer";
import {Protected} from "./routingWrappers";
import {
    MANAGE_ANALYTICS_ROLES,
    MANAGE_CONTRACTORS_ROLES,
    MANAGE_INVENTORY_ROLES,
    MANAGE_OPERATIONS_ROLES,
    MANAGE_PRODUCTS_ROLES,
    MANAGE_PRODUCTION_ROLES,
    MANAGE_SETTINGS_ROLES,
    MANAGE_USERS_ROLES,
    MANAGE_WAREHOUSES_ROLES,
    READ_ANALYTICS_ROLES,
    READ_CONTRACTORS_ROLES,
    READ_INVENTORY_ROLES,
    READ_OPERATIONS_ROLES,
    READ_PRODUCTS_ROLES,
    READ_PRODUCTION_ROLES,
    READ_STOCK_ROLES,
    READ_WAREHOUSES_ROLES
} from "../../helpers/applicationUserHelper";

const PipedrivePanel = React.lazy(() => import("../pipedrivePanel/pipedrivePanel"));
const PipedriveOrderPreview = React.lazy(() => import("../pipedriveOrderPreview/pipedriveOrderPreview"));
const PipedriveSettings = React.lazy(() => import("../pipedriveSettings/pipedriveSettings"));

export const PipedrivePanelPage = () => <React.Suspense fallback={loadingSpin}>
    <PipedrivePanel/>
</React.Suspense>

export const PipedriveOrderPreviewPage = () => <React.Suspense fallback={loadingSpin}>
    <PipedriveOrderPreview/>
</React.Suspense>

export const PipedriveSettingsPage = () => <React.Suspense fallback={loadingSpin}>
    <PipedriveSettings/>
</React.Suspense>

const Main = React.lazy(() => import("../mainPage/mainPage"));

export const MainPage = () => <Protected loadingIndicator={loadingSpin}>
    <Main/>
</Protected>

const UserTableContainer = React.lazy(() => import("../users/userListContainer"));

export const UserPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_USERS_ROLES}>
    <UserTableContainer/>
</Protected>
const UserFormContainer = React.lazy(() => import("../users/userForm/userFormContainer"));

export const UserFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_USERS_ROLES}>
    <UserFormContainer/>
</Protected>

const UserDetailsContainer = React.lazy(() => import("../users/userDetailsContainer"));
export const UserDetailsPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_USERS_ROLES}>
    <UserDetailsContainer/>
</Protected>

const WarehouseTableContainer = React.lazy(() => import("../warehouse/warehouseListContainer"));

export const WarehousePage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_WAREHOUSES_ROLES}>
    <WarehouseTableContainer/>
</Protected>
const WarehouseFormContainer = React.lazy(() => import("../warehouse/warehouseForm/warehouseFormContainer"));

export const WarehouseFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_WAREHOUSES_ROLES}>
    <WarehouseFormContainer/>
</Protected>
const WarehouseDetailsContainer = React.lazy(() => import("../warehouse/warehouseDetailsContainer"));

export const WarehouseDetailsPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_WAREHOUSES_ROLES}>
    <WarehouseDetailsContainer/>
</Protected>
const ProductTableContainer = React.lazy(() => import("../product/productListContainer"));

export const ProductPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_PRODUCTS_ROLES}>
    <ProductTableContainer/>
</Protected>
const ProductHistoryContainer = React.lazy(() => import("../product/productHistoryContainer"));
export const ProductUpdateHistoryPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_PRODUCTS_ROLES}>
    <ProductHistoryContainer/>
</Protected>
const ProductFormContainer = React.lazy(() => import("../product/productForm/productFormContainer"));

export const ProductFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_PRODUCTS_ROLES}>
    <ProductFormContainer/>
</Protected>
const StockTableContainer = React.lazy(() => import("../stock/stockListContainer"));

export const StockPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_STOCK_ROLES}>
    <StockTableContainer/>
</Protected>

const ProductBatchStockContainer = React.lazy(() => import("../stock/productBatchStockContainer"))

export const ProductBatchStockPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_STOCK_ROLES}>
    <ProductBatchStockContainer/>
</Protected>

const StockHistoryContainer = React.lazy(() => import("../stock/stockHistoryContainer"));

export const StockHistoryPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_STOCK_ROLES}>
    <StockHistoryContainer/>
</Protected>

const StockOperationTableContainer = React.lazy(() => import("../stockOperation/stockOperationListContainer"));

export const StockOperationPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_OPERATIONS_ROLES}>
    <StockOperationTableContainer/>
</Protected>
const StockOperationFormContainer = React.lazy(() => import("../stockOperation/stockOperationForm/stockOperationFormContainer"));

export const StockOperationFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_OPERATIONS_ROLES}>
    <StockOperationFormContainer/>
</Protected>

const ProductionStockOperationFormContainer = React.lazy(() => import("../stockOperation/ProductionStockOperation/productionStockOperationFormContainer"));

export const ProductionStockOperationFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_PRODUCTION_ROLES}>
    <ProductionStockOperationFormContainer/>
</Protected>


const StockOperationDetails = React.lazy(() => import("../stockOperation/stockOperationDetails/stockOperationDetails"));

export const StockOperationDetailsPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_OPERATIONS_ROLES}>
    <StockOperationDetails/>
</Protected>

const InternalStockOperationDetails = React.lazy(() => import("../internalStockOperation/internalStockOperationDetails/internalStockOperationDetails"));

export const InternalStockOperationDetailsPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_OPERATIONS_ROLES}>
    <InternalStockOperationDetails/>
</Protected>

const ProductionStockOperationDetails = React.lazy(()=> import("../internalStockOperation/internalStockOperationDetails/productionStockOperationDetails"))

export const ProductionStockOperationDetailsPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_PRODUCTION_ROLES}>
    <ProductionStockOperationDetails/>
</Protected>

const ProcessStockOperationDetails = React.lazy(() => import("../productionProcess/productionProcessDetails/ProductionProcessDetails"))

export const ProcessStockOperationDetailsPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_PRODUCTION_ROLES}>
    <ProcessStockOperationDetails/>
</Protected>

const VinificationOperationForm = React.lazy(() => import("../stockOperation/vinificationStockOperationForms/vinificationFormContainer"))

export const VinificationStockOperationForm = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_PRODUCTION_ROLES}>
    <VinificationOperationForm/>
</Protected>


const CompanyDataContainer = React.lazy(() => import("../companyData/companyDataContainer"));

export const CompanyDataPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_SETTINGS_ROLES}>
    <CompanyDataContainer/>
</Protected>
const CompanyDataFormContainer = React.lazy(() => import("../companyData/companyDataForm/companyDataFormContainer"));

export const CompanyDataFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_SETTINGS_ROLES}>
    <CompanyDataFormContainer/>
</Protected>
const CompanyDataHistoryContainer = React.lazy(() => import("../companyData/companyDataHistoryContainer"));

export const CompanyDataHistoryPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_SETTINGS_ROLES}>
    <CompanyDataHistoryContainer/>
</Protected>

const UnitOfMeasureTableContainer = React.lazy(() => import("../unitOfMeasure/unitOfMeasureListContainer"));

export const UnitOfMeasurePage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_PRODUCTS_ROLES}>
    <UnitOfMeasureTableContainer/>
</Protected>
const UnitOfMeasureFormContainer = React.lazy(() => import("../unitOfMeasure/unitOfMeasureForm/unitOfMeasureFormContainer"));

export const UnitOfMeasureFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_PRODUCTS_ROLES}>
    <UnitOfMeasureFormContainer/>
</Protected>
const StockOperationUpdateHistoryTableContainer = React.lazy(() => import("../stockOperation/stockOperationHistoryContainer"));

export const StockOperationUpdateHistoryPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_OPERATIONS_ROLES}>
    <StockOperationUpdateHistoryTableContainer/>
</Protected>
const GeneralStockContainer = React.lazy(() => import("../stock/generalStock/generalStockContainer"));

export const GeneralStockPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_STOCK_ROLES}>
    <GeneralStockContainer/>
</Protected>
const StockReservationHistoryContainer = React.lazy(() => import("../stock/stockReservationHistoryContainer"));

export const StockReservationHistoryPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_STOCK_ROLES}>
    <StockReservationHistoryContainer/>
</Protected>
const WarehouseOperationsCalendarContainer = React.lazy(() => import("../fullScreenCalendar/fullScreenCalendar"));

export const WarehouseOperationsCalendarPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_OPERATIONS_ROLES}>
    <WarehouseOperationsCalendarContainer/>
</Protected>

const ContractorTableContainer = React.lazy(() => import("../contractor/contractorListContainer"));

export const ContractorPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_CONTRACTORS_ROLES}>
    <ContractorTableContainer/>
</Protected>
const ContractorDetailsContainer = React.lazy(() => import("../contractor/contractorDetails/contractorDetailsContainer"));

export const ContractorDetailsPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_CONTRACTORS_ROLES}>
    <ContractorDetailsContainer/>
</Protected>
const ContractorFormContainer = React.lazy(() => import("../contractor/contractorForm/contractorFormContainer"));

export const ContractorFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_CONTRACTORS_ROLES}>
    <ContractorFormContainer/>
</Protected>
const ContractorHistoryContainer = React.lazy(() => import("../contractor/contractorHistoryContainer"));

export const ContractorHistoryPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_CONTRACTORS_ROLES}>
    <ContractorHistoryContainer/>
</Protected>
const ContractorOperationHistoryContainer = React.lazy(() => import("../contractor/contractorOperationHistoryContainer"));

export const ContractorOperationHistoryPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_CONTRACTORS_ROLES}>
    <ContractorOperationHistoryContainer/>
</Protected>


const InventoryOperationTableContainer = React.lazy(() => import("../inventoryOperation/inventoryOperationListContainer"));

export const InventoryOperationPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_INVENTORY_ROLES}>
    <InventoryOperationTableContainer />
</Protected>
const InventoryOperationFormContainer = React.lazy(() => import("../inventoryOperation/inventoryOperationForm/inventoryOperationFormContainer"));

export const InventoryOperationFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_INVENTORY_ROLES}>
    <InventoryOperationFormContainer />
</Protected>
const ProductionProcessTableContainer = React.lazy(() => import("../productionProcess/productionProcessListContainer"));

export const ProductionProcessPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_PRODUCTION_ROLES}>
    <ProductionProcessTableContainer />
</Protected>
const ProductionProcessFormContainer = React.lazy(() => import("../productionProcess/productionProcessForm/productionProcessFormContainer"));

export const ProductionProcessFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_PRODUCTION_ROLES}>
    <ProductionProcessFormContainer />
</Protected>
const CropTableContainer = React.lazy(() => import("../crop/cropListContainer"));

export const CropPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_PRODUCTION_ROLES}>
    <CropTableContainer />
</Protected>

const CropDetails = React.lazy(() => import("../crop/cropDetails"))

export const CropDetailsPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_PRODUCTION_ROLES}>
    <CropDetails />
</Protected>

const CropFormContainer = React.lazy(() => import("../crop/cropForm/cropFormContainer"));

export const CropFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_PRODUCTION_ROLES}>
    <CropFormContainer />
</Protected>
const StrainTableContainer = React.lazy(() => import("../strain/strainListContainer"));

export const StrainPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_PRODUCTS_ROLES}>
    <StrainTableContainer />
</Protected>
const StrainFormContainer = React.lazy(() => import("../strain/strainForm/strainFormContainer"));

export const StrainFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_PRODUCTS_ROLES}>
    <StrainFormContainer />
</Protected>
const PhysicochemicalTestTableContainer = React.lazy(() => import("../physicochemicalTest/physicochemicalTestListContainer"));

export const PhysicochemicalTestPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_ANALYTICS_ROLES}>
    <PhysicochemicalTestTableContainer />
</Protected>
const PhysicochemicalTestFormContainer = React.lazy(() => import("../physicochemicalTest/physicochemicalTestForm/physicochemicalTestFormContainer"));

export const PhysicochemicalTestFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_ANALYTICS_ROLES}>
    <PhysicochemicalTestFormContainer />
</Protected>

const StrainDetails = React.lazy(() => import("../strain/strainDetails"));

export const StrainDetailsPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_PRODUCTS_ROLES}>
    <StrainDetails />
</Protected>
const ProductPriceTableContainer = React.lazy(() => import("../productPrice/productPriceListContainer"));

export const ProductPricePage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={READ_PRODUCTS_ROLES}>
    <ProductPriceTableContainer />
</Protected>
const ProductPriceFormContainer = React.lazy(() => import("../productPrice/productPriceForm/productPriceFormContainer"));

export const ProductPriceFormPage = () => <Protected loadingIndicator={loadingSpin} allowedForRoles={MANAGE_PRODUCTS_ROLES}>
    <ProductPriceFormContainer />
</Protected>
